/* eslint-disable no-nested-ternary */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from '..';

/**
 * AlertModal Component
 *
 */

const AlertModal = ({
    modalIsOpen,
    closeModal,
    primaryButtonText,
    secondaryButtonText,
    showActions,
    message,
    currentSection,
    onSuccessModal,
    headerText,
}) => (
    <Modal
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        customWrapperClass="alert-modal-wrapper"
    >
        <div className="alert-message">
            <div className="title-alert">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    className="warning-icon"
                >
                    <title>Error Indicator</title>
                    <path d="M29.867 25.6c0 1.178-0.955 2.133-2.133 2.133s-2.133-0.955-2.133-2.133c0-1.178 0.955-2.133 2.133-2.133s2.133 0.955 2.133 2.133z" />
                    <path d="M18.133 5.333c0 1.179-0.955 1.067-2.133 1.067s-2.133 0.112-2.133-1.067 0.955-2.133 2.133-2.133 2.133 0.955 2.133 2.133z" />
                    <path d="M6.4 25.6c0 1.178-0.955 2.133-2.133 2.133s-2.133-0.955-2.133-2.133c0-1.178 0.955-2.133 2.133-2.133s2.133 0.955 2.133 2.133z" />
                    <path d="M17.958 4.491l-1.958-0.224-1.958 0.224-11.588 19.987 1.967 3.255h23.159l1.967-3.255-11.588-19.987zM17.293 12.117l-0.213 6.905h-2.159l-0.213-6.905h2.586zM16.003 23.668c-0.883 0-1.411-0.47-1.411-1.261 0-0.805 0.527-1.276 1.411-1.276 0.877 0 1.404 0.47 1.404 1.276 0 0.79-0.527 1.261-1.404 1.261z" />
                </svg>
                {currentSection ? (
                    <div>You have made changes in {currentSection.name}</div>
                ) : headerText ? (
                    <div>{headerText}</div>
                ) : (
                    <div>Some sections are in open state</div>
                )}
            </div>
            <p className="message">{message}</p>
        </div>
        {showActions ? (
            <div className="action-buttons">
                {primaryButtonText ? (
                    <button
                        type="button"
                        className="button primary"
                        onClick={onSuccessModal}
                    >
                        {primaryButtonText}
                    </button>
                ) : null}
                {secondaryButtonText ? (
                    <button
                        type="button"
                        className="button secondary"
                        onClick={closeModal}
                    >
                        {secondaryButtonText}
                    </button>
                ) : null}
            </div>
        ) : null}
    </Modal>
);

AlertModal.propTypes = {
    modalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onSuccessModal: PropTypes.func,
    primaryButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    showActions: PropTypes.bool,
    message: PropTypes.string,
    currentSection: PropTypes.string,
    headerText: PropTypes.string,
};

export default AlertModal;
